module.exports = __webpack_public_path__ + "static/img/yz_fw.f669bc88.png";